import { render, staticRenderFns } from "./horizontal_wizard_item.vue?vue&type=template&id=0f796154&scoped=true&"
import script from "./horizontal_wizard_item.vue?vue&type=script&lang=js&"
export * from "./horizontal_wizard_item.vue?vue&type=script&lang=js&"
import style0 from "./horizontal_wizard_item.vue?vue&type=style&index=0&id=0f796154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f796154",
  null
  
)

export default component.exports